import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class IntermissionImage extends BaseOption {
  static userInterfaceComponent = {
    label: "Break screen image",
    optionDataType: BaseOption.DataType.String,
    component: inspectorTools.MEDIA_PICKER,
    descriptionMessage: "Shown to viewers while the host is on a technical break. Falls back to the event cover.",
    props: { mediaType: "image" },
  };

  static defaultValue = "";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "none" || configValue === null || configValue === undefined) {
      return "";
    }
    return String(configValue);
  }
}
